import { createRouter, createWebHistory } from "vue-router";
import store from "./store";

import Home from "./views/Home.vue";
import About from "./views/About.vue";
import Perfil from "./views/Perfil.vue";
import Dashboard from "./views/DashBoard.vue";
import Administrador from "./views/Administrador.vue";
import Configuraciones from "./views/Configuraciones.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/Dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: { requiresAuth: true },
  },
  {
    path: "/about",
    name: "About",
    component: About,
    meta: { requiresAuth: true },
  },
  {
    path: "/Perfil",
    name: "Perfil",
    component: Perfil,
    meta: { requiresAuth: true },
  },
  {
    path: "/Administrador",
    name: "Administrador",
    component: Administrador,
    meta: { requiresAuth: true },
  },
  {
    path: "/Configuraciones",
    name: "Configuraciones",
    component: Configuraciones,
    meta: { requiresAuth: true },
  },
  {
    path: "/Lecciones",
    name: "Lecciones",
    component: () => import("./views/Lecciones.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/Preguntas",
    name: "Preguntas",
    component: () => import("./views/Preguntas.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/MaterialEstudio",
    name: "MaterialEstudio",
    component: () => import("./views/MaterialEstudio.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/LogsMaterial",
    name: "LogsMaterial",
    component: () => import("./views/LogsMaterial.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/Traducciones",
    name: "Traducciones",
    component: () => import("./views/Traducciones.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/Glosario",
    name: "Glosario",
    component: () => import("./views/Glosario.vue"),
    meta: { requiresAuth: true },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return false;
  },
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !store.state.auth.token) {
    next({ name: "Home" });
  } else {
    next();
  }
});

export default router;
